export default __webpack_public_path__ + "static/media/card-top.5b26f3ea.svg";